import { render } from "./ManualesView.vue?vue&type=template&id=4a8ee28a&scoped=true"
import script from "./ManualesView.vue?vue&type=script&lang=js"
export * from "./ManualesView.vue?vue&type=script&lang=js"

import "./ManualesView.vue?vue&type=style&index=0&id=4a8ee28a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a8ee28a"]])

export default __exports__